module.exports = __webpack_public_path__ + "img/linkedin.9100f1ba.svg";